import { createSlice } from '@reduxjs/toolkit';
import { athkarEsalah} from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';



const athkarEslahSlice = createSlice({
  name: 'athkarEsalah',
  initialState: athkarEsalah,
  reducers: {
    showInfoSL: showInfoAct,
    numDecreaseSL: numDecreaseAct,
    prograssNumSL:prograssNum
  },
});

export const { showInfoSL, numDecreaseSL,prograssNumSL } = athkarEslahSlice.actions;
export default athkarEslahSlice.reducer;